import { v4 as uuid } from "uuid";
import * as CubiqTS from "../../index";
import { LinkedOrderRequest } from "../LinkedOrderRequest";
import { LinkedOrderRequestImpl } from "./LinkedOrderRequestImpl";
import { OrderRequestDataImpl } from "./OrderRequestDataImpl";

export const INFO_RUNGS_MID: string = "RUNGS_MID";
export const INFO_RUNGS_ABOVE: string = "RUNGS_ABOVE";
export const INFO_RUNGS_BELOW: string = "RUNGS_BELOW";

export class GammaOrderRequestImpl extends LinkedOrderRequestImpl implements LinkedOrderRequest {
  public static enType: string = "com.bcdfx.model.event.GammaOrderRequestImpl";

  constructor() {
    super();
    this.encoder = CubiqTS.GammaOrderRequestImplEncoder.Instance;
    this.setEncodableType(GammaOrderRequestImpl.enType);
    this.messageId = uuid();
  }

  public get rungsAbove(): number {
    let rungsAboveCount: number = null;

    if (this.extendedInfo != null && this.extendedInfo.has(INFO_RUNGS_ABOVE)) {
      rungsAboveCount = parseInt(this.extendedInfo.get(INFO_RUNGS_ABOVE), 10);
    }

    return rungsAboveCount;
  }

  public set rungsAbove(rungsAboveCount: number) {
    this.extendedInfo.set(INFO_RUNGS_ABOVE, rungsAboveCount + "");
  }

  public get rungsBelow(): number {
    let rungsBelowCount: number = null;

    if (this.extendedInfo != null && this.extendedInfo.has(INFO_RUNGS_BELOW)) {
      rungsBelowCount = parseInt(this.extendedInfo.get(INFO_RUNGS_BELOW), 10);
    }

    return rungsBelowCount;
  }

  public set rungsBelow(rungsBelowCount: number) {
    this.extendedInfo.set(INFO_RUNGS_BELOW, rungsBelowCount + "");
  }

  public get midRungIndex(): number {
    let midRungIndex: number = null;

    if (this.extendedInfo != null && this.extendedInfo.has(INFO_RUNGS_MID)) {
      midRungIndex = parseInt(this.extendedInfo.get(INFO_RUNGS_MID), 10);
    }

    return midRungIndex;
  }

  public set midRungIndex(midRungIndex: number) {
    this.extendedInfo.set(INFO_RUNGS_MID, midRungIndex + "");
  }

  public getMidRung(): OrderRequestDataImpl {
    let midRung: OrderRequestDataImpl = null;

    if (
      this.rootOrder != null &&
      this.extendedInfo != null &&
      this.extendedInfo.has(INFO_RUNGS_MID)
    ) {
      midRung = this.getRung(this.midRungIndex);
    }

    return midRung;
  }

  public getOrderedRungs(): Array<OrderRequestDataImpl> {
    let rungs: Array<OrderRequestDataImpl> = [];

    if (this.rootOrder != null) {
      for (let i: number = 1; i <= this.getTotalRungs(); ++i) {
        rungs.push(this.getRung(i));
      }
    }

    return rungs;
  }

  public getRung(rungIndex: number): OrderRequestDataImpl {
    let rung: OrderRequestDataImpl = null;

    if (this.rootOrder != null && rungIndex > 0) {
      if (rungIndex == 1) {
        rung = this.rootOrder;
      } else if (
        this.rootOrder.childRelationships &&
        this.rootOrder.childRelationships.length > 0
      ) {
        rung = this.getChild(this.rootOrder, 1, rungIndex);
      }
    }

    return rung;
  }

  protected getChild(
    data: OrderRequestDataImpl,
    dept: number,
    index: number,
  ): OrderRequestDataImpl {
    if (dept === index) {
      return data;
    }

    return data.childRelationships && data.childRelationships.length > 0
      ? this.getChild(data.childRelationships[0].order, dept + 1, index)
      : null;
  }

  public getRungsAbove(): number {
    let result: number = null;

    if (this.extendedInfo != null && this.extendedInfo.has(INFO_RUNGS_ABOVE)) {
      result = parseInt(this.extendedInfo.get(INFO_RUNGS_ABOVE), 10);
    }

    return result;
  }

  public getRungsBelow(): number {
    let result: number = null;

    if (this.extendedInfo != null && this.extendedInfo.has(INFO_RUNGS_BELOW)) {
      result = parseInt(this.extendedInfo.get(INFO_RUNGS_BELOW), 10);
    }

    return result;
  }

  public getTotalRungs(): number {
    return this.getRungsAbove() + this.getRungsBelow() + 1;
  }

  public toString(): string {
    return (
      "GammaOrderRequestImpl[" +
      "product=" +
      this.product +
      "comment1=" +
      this.comment1 +
      "comment2=" +
      this.comment2 +
      "client=" +
      this.client +
      "account=" +
      this.account +
      "linkReference=" +
      this.linkReference +
      "rootOrder=" +
      this.rootOrder +
      "clientTrader=" +
      this.clientTrader +
      "stpHold=" +
      this.stpHold +
      "scratchPadOrder=" +
      this.scratchPadOrder +
      "oboClient=" +
      this.oboClient +
      "oboAccount=" +
      this.oboAccount +
      "oboUser=" +
      this.oboUser +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "]"
    );
  }
}
